import { generateState } from '../builder'

export default {
  adaptationFormats: [],
  ...generateState('getAdaptationFormats'),
}
